import {FC} from "react";

const Header: FC = () => {

  return (
    <>
      <header>
        <a href="" className="image-fluid">
          <img src="images/header-image.png" />
        </a>
        <h1> Self learning by Bestlearn </h1>
        <h2> Experience and Enter Job Market </h2>
      </header>
    </>
  );
};

export default Header;
